import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Rectangular flower planter: a plank box with a soil top and five small
// flower heads on thin stems, in the kit's two muted accent colours.
const PLANK = "#c8975a";
const SOIL = "#5a4632";
const STEM = "#5f8f4e";
const RED = "#b05a4a";
const YELLOW = "#d0b05a";

// [x, z, colour] for each flower.
const FLOWERS: Array<[number, number, string]> = [
  [-0.28, -0.03, RED],
  [-0.14, 0.04, YELLOW],
  [0.0, -0.04, RED],
  [0.14, 0.03, YELLOW],
  [0.28, -0.02, RED],
];

export const flowerPlanter = defineModel({
  id: "flower-planter",
  batchId: "modern",
  name: "Flower planter",
  tags: ["modern", "outdoor", "garden", "planter", "flower", "plant"],
  summary: "A rectangular plank planter box with five small flowers.",
  description:
    "A rectangular planter of the Modern Living kit: a 0.8 x 0.3 x 0.3 m " +
    "plank box with a soil top and five small flower heads on thin stems in " +
    "muted red and yellow. A dressing piece for gardens, patios and streets.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    const parts: Part[] = [
      { geometry: new THREE.BoxGeometry(0.8, 0.3, 0.3), color: PLANK, position: [0, 0.15, 0] },
      { geometry: new THREE.BoxGeometry(0.72, 0.03, 0.22), color: SOIL, position: [0, 0.3, 0] },
    ];
    for (const [x, z, color] of FLOWERS) {
      parts.push({
        geometry: new THREE.CylinderGeometry(0.008, 0.008, 0.12, 5),
        color: STEM,
        position: [x, 0.37, z],
      });
      parts.push({
        geometry: new THREE.SphereGeometry(0.035, 6, 5),
        color,
        position: [x, 0.44, z],
      });
    }
    return parts;
  },
  animations: [],
});
